import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  FormHelperText,
  Grid,CircularProgress
} from "@mui/material";
import { IconButton } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../AuthProvider";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {useParams, useLocation } from "react-router-dom";

export const HostelRegistrationForm = () => {
  const navigate = useNavigate();
   const { studentId } = useParams();

  const [errors, setErrors] = useState({});
  const [searchError, setSearchError] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const { userId, oId, role ,board,pId} = useAuth();
  const [busLoading, setBusLoading] = useState(false);
  const [routeNumberLoading, setRouteNumberLoading] = useState(false);
  const [locationLoading, setLocationLoading] = useState(false);
  const [busNumbers, setBusNumbers] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [routeLoading, setRouteLoading] = useState(false);
  const [routeNumber, setrouteNumber] = useState([]);
  const [loading, setLoading] = useState(false); // State to track loading

   const [users, setUsers] = useState([]);
   const [stops, setStops] = useState([]);
   const [selectedUsers, setSelectedUsers] = useState('');
   const isPrincipal = role?.startsWith("PRINCIPAL") || false;
   const UserId = userId || selectedUsers;

   const [isDisabled, setIsDisabled] = useState(false);


  const [formData, setFormData] = useState({
    admissionNumber: "",
    firstName: "",
    lastName: "",
    romanNumberClass:"",
    course:"",
    sections:"",
    fatherName: "",
    // primaryContact: "",
    fatherPhoneNumber: "",
    address: "",
    gender: "",
   
    hostelTotalFee: "",
    email: "",
  });
  

  const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" },
  ];


  const [adminusers, setadminUsers] = useState([]);
  const [selectedadminUsers, setSelectedadminUsers] = useState("");

  console.log("Selected admin:",selectedadminUsers);

  useEffect(() => {
    const fetchUsers = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/ADMISSION_FEE/${oId}/${pId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch users');
            }
            const data = await response.json();
            setadminUsers(data);
            if (data.length > 0) {
              setSelectedadminUsers(data[0].userId); // ✅ Set first record's userId as default
          }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

  // if (isPrincipal) {
    fetchUsers();
  // }
}, []); // ✅ Only runs on mount 


    const fetchUsers = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/TRANSPORT/${oId}/${pId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch users');
            }
            const data = await response.json();
            setUsers(data);
            if (data.length > 0) {
              setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
          }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
  useEffect(() => {
    if (isPrincipal) {
        fetchUsers();
    }
}, []);


  const handleInputChange = (event) => {
    const { name, value } = event.target;
    console.log(`Field Updated: ${name}, New Value: ${value}`);
  
    setFormData((prevData) => {
      let updatedFormData = { ...prevData, [name]: value };
      return updatedFormData;
    });
  
    // Validate and update errors
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value.trim() ? "" : `${name.replace(/([A-Z])/g, " $1")} is required`,
    }));
  };

  const fetchStudentDetails = async () => {
    if (!studentId) return;
    if (!oId) {
      setSearchError("Organization ID is missing.");
      return;
    }
  
    try {
      setSearchError("");
      setIsSearching(true);
  
      const response = await fetch(
        // `${baseUrl}/api/admission/getAllStudentsDetailsGeneratedAdmId/${formData.admissionNumber}/${oId}/${pId}`
         `${baseUrl}/api/admission/getAllSpecificStudentsDetails/${studentId}/${oId}`
      );
  
      const data = await response.json();
  
      if (response.ok && data) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          firstName: data.firstName || "",
          lastName: data.lastName || "",
          fatherName: `${data.fathersFirstName} ${data.fathersLastName}` || "",
          fatherPhoneNumber: data.primaryContact || "",
          address: data.address || "",
          gender: data.gender || "",
          email: data.fathersMailId || "",
          romanNumberClass : data.romanNumberClass || "",
          course:data.course || "",
          sections:data.sections || "",
          studentId:data.studentId || "",
        }));
      } else {
        setSearchError("No record found for this Admission No.");
      }
    } catch (error) {
      setSearchError("Admission Details are Not Found.");
    } finally {
      setIsSearching(false);
    }
  };
   useEffect(() => {
        fetchStudentDetails();
}, [studentId,oId]);
  

 

  const validateForm = () => {
    const newErrors = {};
    if (!formData.firstName)
      newErrors.firstName = "First Name is required";
    if (!formData.lastName)
      newErrors.lastName = "Last Name is required";
    if (!formData.fatherName)
      newErrors.fatherName = "Father's Name is required";
    if (!formData.romanNumberClass)
      newErrors.romanNumberClass = "Class is required";
    if (!formData.sections)
      newErrors.sections = "Section is required";

    if (!/^\d{12}$/.test(formData.fatherPhoneNumber))
      newErrors.fatherPhoneNumber = "Invalid Phone Number";
    // if (!formData.address) newErrors.address = "Address is required";
    // if (!formData.gender) newErrors.gender = "Gender is required";

    if (!formData.hostelTotalFee)
      newErrors.hostelTotalFee = "Hostel Fee Amount is required";

    // if (!formData.email) newErrors.email = "Email is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); // Start loading

      const formDataToSend = new FormData();
      formDataToSend.append("firstName", formData.firstName);
      formDataToSend.append("lastName", formData.lastName);
      formDataToSend.append("romanNumberClass", formData.romanNumberClass);
      formDataToSend.append("sections", formData.sections);
      formDataToSend.append("fatherName", formData.fatherName);
      formDataToSend.append("fatherPhoneNumber", formData.fatherPhoneNumber);
      formDataToSend.append("address", formData.address);
      formDataToSend.append("gender", formData.gender);
      formDataToSend.append("hostelTotalFee", formData.hostelTotalFee);

      try {
        const response = await fetch(
          `${baseUrl}/api/hostelFee/save/${formData.studentId}/${oId}/${pId}`,
          {
            method: "POST",
            body: formDataToSend,
          }
        );
        
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(
            `Error: ${errorText}`
          );
        }

        toast.success("Student Registered successfully!", { autoClose: 1000 });
        // Delay navigation to let toast display
          setTimeout(() => {
            navigate('/HostelFeesList');
        }, 1000);

        
      } catch (error) {
        console.error("Error submitting form:", error);

        // Corrected error handling
        toast.error(error.message || "Failed to submit Student Registration. Please try again.", {
            autoClose: 2000,
        });
      }finally {
        setLoading(false); // Stop loading
      }
    }
  };

  return (
    <Box
      style={{
        margin: "60px 20px",
        padding: "10px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        Height: "100vh",
        overflow: "hidden",
      }}
    >
      <Box display="flex" alignItems="center" sx={{ marginBottom: 2 }}>
        <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
          <KeyboardBackspaceIcon fontSize="medium" />
        </IconButton>
        <Typography variant="h4" component="h3" sx={{ fontWeight: "bold" }}>
          Student Hostel Registration Form
        </Typography>
      </Box>



      {/* Form onSubmit={handleSubmit} */}
      <form>
        <Box display="grid" gridTemplateColumns="repeat(3, 1fr)" gap="20px">

<TextField
  fullWidth
  label="Student First Name"
  name="firstName"
  value={formData.firstName}
  onChange={handleInputChange}
  error={!!errors.firstName}
  helperText={errors.firstName}

  InputProps={{
                readOnly: true,
                sx: {
                  backgroundColor: "#e0e0e0",
                  color: "#666",
                  borderRadius: "5px",
                  fontWeight:'bold',
                  pointerEvents: "none", 
                  "& .MuiInputBase-input": { color: "#666", cursor: "default" },
                },
              }}
/>


          
          

<TextField
  fullWidth
  label="Student Last Name"
  name="lastName"
  value={formData.lastName || "N/A"}
  onChange={handleInputChange}
  error={!!errors.lastName}
  helperText={errors.lastName}

  InputProps={{
                readOnly: true,
                sx: {
                  backgroundColor: "#e0e0e0",
                  color: "#666",
                  fontWeight:'bold',
                  borderRadius: "5px",
                  pointerEvents: "none", 
                  "& .MuiInputBase-input": { color: "#666", cursor: "default" },
                },
              }}
/>

<TextField
  fullWidth
  label={board === "INTERMEDIATE" ? "Year" : "Class"}
  name="romanNumberClass"
  value={`${formData.romanNumberClass}`}
  onChange={handleInputChange}
  error={!!errors.romanNumberClass}
  helperText={errors.romanNumberClass}
  InputProps={{
                readOnly: true,
                sx: {
                  backgroundColor: "#e0e0e0",
                  color: "#666",
                  fontWeight:'bold',
                  borderRadius: "5px",
                  pointerEvents: "none", 
                  "& .MuiInputBase-input": { color: "#666", cursor: "default" },
                },
              }}
/>

{board === "INTERMEDIATE" && (
  <TextField
    fullWidth
    label="Course"
    name="course"
    value={`${formData.course}`}
    InputProps={{
                readOnly: true,
                sx: {
                  backgroundColor: "#e0e0e0",
                  color: "#666",
                  fontWeight:'bold',
                  borderRadius: "5px",
                  pointerEvents: "none", 
                  "& .MuiInputBase-input": { color: "#666", cursor: "default" },
                },
              }}
  />
)}

<TextField
  fullWidth
  label="Section"
  name="sections"
  value={formData.sections}
  onChange={handleInputChange}
  error={!!errors.sections}
  helperText={errors.sections}
  InputProps={{
                readOnly: true,
                sx: {
                  backgroundColor: "#e0e0e0",
                  color: "#666",
                  fontWeight:'bold',
                  borderRadius: "5px",
                  pointerEvents: "none", 
                  "& .MuiInputBase-input": { color: "#666", cursor: "default" },
                },
              }}
/>

<TextField
  fullWidth
  label="Father's Name"
  name="fatherName"
  value={formData.fatherName}
  onChange={handleInputChange}
  error={!!errors.fatherName}
  helperText={errors.fatherName}

  InputProps={{
                readOnly: true,
                sx: {
                  backgroundColor: "#e0e0e0",
                  color: "#666",
                  fontWeight:'bold',
                  borderRadius: "5px",
                  pointerEvents: "none", 
                  "& .MuiInputBase-input": { color: "#666", cursor: "default" },
                },
              }}
/>

<TextField
  fullWidth
  label="Father's Phone Number"
  name="fatherPhoneNumber"
  value={formData.fatherPhoneNumber}
  onChange={handleInputChange}
  error={!!errors.fatherPhoneNumber}
  helperText={errors.fatherPhoneNumber}

  InputProps={{
                readOnly: true,
                sx: {
                  backgroundColor: "#e0e0e0",
                  color: "#666",
                  fontWeight:'bold',
                  borderRadius: "5px",
                  pointerEvents: "none", 
                  "& .MuiInputBase-input": { color: "#666", cursor: "default" },
                },
              }}
/>

<TextField
  fullWidth
  label="Address"
  name="address"
  value={formData.address || "N/A"}
  onChange={handleInputChange}
  error={!!errors.address}
  helperText={errors.address}

  InputProps={{
                readOnly: true,
                sx: {
                  backgroundColor: "#e0e0e0",
                  color: "#666",
                  fontWeight:'bold',
                  borderRadius: "5px",
                  pointerEvents: "none", 
                  "& .MuiInputBase-input": { color: "#666", cursor: "default" },
                },
              }}
             
/>

<TextField
  fullWidth
  label="Gender"
  name="gender"
  value={formData.gender}
  onChange={handleInputChange}
  error={!!errors.gender}
  helperText={errors.gender}

  InputProps={{
                readOnly: true,
                sx: {
                  backgroundColor: "#e0e0e0",
                  color: "#666",
                  fontWeight:'bold',
                  borderRadius: "5px",
                  pointerEvents: "none", 
                  "& .MuiInputBase-input": { color: "#666", cursor: "default" },
                },
              }}
/>

          <TextField
  fullWidth
  label="Hostel Total Fee "
  name="hostelTotalFee"
  placeholder="Enter Amount"
  value={formData.hostelTotalFee}
  onChange={(e) => {
    const val = e.target.value;
    if (/^\d*$/.test(val) && val.length <= 10) {
      handleInputChange(e); // ✅ Update only if numeric and within 10 digits
    }
  }}
  onKeyDown={(e) => {
    const allowedKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab"
    ];
    if (!/^\d$/.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault(); // 🚫 Block non-digit and non-control keys
    }
  }}
  inputProps={{
    inputMode: "numeric",
    maxLength: 10, // for mobile keyboards & safety
  }}
  error={!!errors.hostelTotalFee}
  helperText={errors.hostelTotalFee}
/>

    


          
        </Box>

        {/* Register Button */}
        <Grid container justifyContent="right" sx={{ marginTop: 4 }}>
          <Grid item>
          <Button
  variant="contained"
  onClick={handleSubmit}
  style={{
    backgroundColor: "#3C3972",
    fontWeight: "bold",
    height: "40px",
    minWidth: "150px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }}
  disabled={loading} // Disable button when loading
>
  {loading ? <CircularProgress size={24} color="inherit" /> : "Register Student"}
</Button>

          </Grid>
        </Grid>
      </form>
      <ToastContainer position="top-right" />
    </Box>
  );
};